var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"text-center p-5"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'spinner'],"spin":"","size":"2x"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }